module.exports = __webpack_public_path__ + "static/media/research-world-class.8ca8abae.webp";